const state = {
  menu1: JSON.parse(sessionStorage.getItem('menu1')) || '', // 一级菜单
  menu2: JSON.parse(sessionStorage.getItem('menu2')) || '', // 二级菜单
  activeMenu: sessionStorage.getItem('activeMenu') || '', // 当前激活菜单
  funcData: JSON.parse(sessionStorage.getItem('funcData')) || [] // 功能权限
}

const mutations = {
  userLogin (state, data) {
    let menu1 = []
    let menu2 = []
    let menu1Min = 0
    let menu2Min = 0
    let funcData = []

    // 区分一二三级菜单
    for (let i = 0; i < data.length; i++) {
      menu1.push({
        id: data[i].id,
        url: data[i].url,
        name: data[i].name,
        sequence: data[i].sortNum,
        pId: data[i].pid,
        icon: data[i].icon
      })
      if (data[i].childList !== null) {
        for (let j = 0; j < data[i].childList.length; j++) {
          if (data[i].childList[j].isOperation === 'N') { // 不是功能模块
            menu2.push({
              id: data[i].childList[j].id,
              url: data[i].childList[j].url,
              name: data[i].childList[j].name,
              sequence: data[i].childList[j].sortNum,
              pId: data[i].childList[j].pid,
              icon: data[i].childList[j].icon
            })
            if (data[i].childList[j].childList !== null) {
              for (let k = 0; k < data[i].childList[j].childList.length; k++) {
                if (data[i].childList[j].childList[k].isOperation === 'Y') { // 功能模块
                  funcData.push({
                    url: data[i].childList[j].url,
                    funcBotton: data[i].childList[j].childList[k].operationCode
                  })
                }
              }
            }
          }
          if (data[i].childList[j].isOperation === 'Y') { // 功能模块
            funcData.push({
              url: data[i].url,
              funcBotton: data[i].childList[j].operationCode
            })
          }
        }
      }
    }

    // 一级菜单排序
    for (let i = 0; i < menu1.length; i++) {
      for (let j = i; j < menu1.length; j++) {
        if (menu1[i].sequence > menu1[j].sequence) {
          menu1Min = menu1[j]
          menu1[j] = menu1[i]
          menu1[i] = menu1Min
        }
      }
    }
    // 二级菜单排序
    for (let i = 0; i < menu2.length; i++) {
      for (let j = i; j < menu2.length; j++) {
        if (menu2[i].pId === menu2[j].pId && menu2[i].sequence > menu2[j].sequence) {
          menu2Min = menu2[j]
          menu2[j] = menu2[i]
          menu2[i] = menu2Min
        }
      }
    }

    state.menu1 = menu1
    state.menu2 = menu2
    state.funcData = funcData
    sessionStorage.setItem('menu1', JSON.stringify(menu1))
    sessionStorage.setItem('menu2', JSON.stringify(menu2))
    sessionStorage.setItem('funcData', JSON.stringify(funcData))
  },
  activeMenu (state, data) {
    state.activeMenu = data
    sessionStorage.setItem('activeMenu', data)
  }
}

const actions = {
  userLogin (context, data) {
    context.commit('userLogin', data)
  },
  activeMenu (context, data) {
    context.commit('activeMenu', data)
  }
}

export default{
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/menus.js